import { useState } from 'react';
import { LuSmile } from 'react-icons/lu';

import { Popover } from '@any-ui-react/core';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import classNames from 'classnames';

import { BaseEmoji, EmojiPicker } from '../../../emoji-picker';

import { INSERT_EMOJI } from './EmojiPlugin';

export const EmojiPopover = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [editor] = useLexicalComposerContext();

  const handleSelect = (emoji: BaseEmoji) => {
    editor.dispatchCommand(INSERT_EMOJI, { emoji: emoji.native });
    setIsOpen(false);
  };

  return (
    <Popover
      opened={isOpen}
      closeOnClickOutside
      onClose={() => setIsOpen(false)}
      position="bottom-start"
      withinPortal
      offset={5}
    >
      <Popover.Target>
        <button
          type="button"
          className={classNames('flex h-6 w-6 items-center justify-center rounded', {
            'bg-gray-2': isOpen,
          })}
          onClick={() => setIsOpen(!isOpen)}
        >
          <LuSmile className="text-gray-7 h-4 w-4" />
        </button>
      </Popover.Target>

      <Popover.Dropdown className="rounded-[0.7rem] border-0 p-0 drop-shadow-none">
        <EmojiPicker onSelect={handleSelect} />
      </Popover.Dropdown>
    </Popover>
  );
};
